/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
// import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

// const promoBgUrl = getAssetUrl('static/img/header-promo-bg-img.jpg');

export default {
    baseStyle: {
        headerIcons: {
            lineHeight: '21px',
            border: 'none',
            fontSize: '10px',
            width: '10px',
            height: '20px',
            left: '21px'
        },
        itemName: {
            fontSize: 'md',
            color: 'woodsmoke',
            lineHeight: '5',
            fontFamily: 'Nutmeg, "Helvetica Neue", Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
            cursor: 'pointer'
        },
        itemQty: {
            fontSize: 'sm'
        }
    },
    parts: ['headerIcons', 'imageStyle', 'itemName', 'itemQty']
}
